import { useState, useEffect } from 'react';
import { Save, Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const SaveScenarioModal = ({ 
  open, 
  onOpenChange, 
  onSave, 
  loading,
  initialName = '',
  initialDescription = '' 
}) => {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);

  // Beim Öffnen mit dem aktuell geladenen Szenario vorbelegen
  useEffect(() => {
    if (open) {
      setName(initialName);
      setDescription(initialDescription);
    }
  }, [open, initialName, initialDescription]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name: name.trim(), description: description.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="save-scenario-modal">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wider text-lunefire-charcoal dark:text-white">
            Szenario speichern
          </DialogTitle>
          <DialogDescription className="font-body">
            Das Szenario wird in diesem Browser gespeichert. Gleicher Name überschreibt das geladene Szenario.
            Zum Weitergeben „Szenario exportieren“ nutzen.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="scenario-name">Name</Label>
            <Input
              id="scenario-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Wohnungsbrand Musterstraße"
              className="font-mono"
              data-testid="scenario-name-input"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="scenario-description">Beschreibung (optional)</Label>
            <Textarea
              id="scenario-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Kurze Beschreibung des Szenarios..."
              rows={3}
              data-testid="scenario-description-input"
            />
          </div>
        </div>

        <DialogFooter>
          <Button 
            variant="ghost" 
            onClick={() => onOpenChange(false)}
            className="hover:bg-lunefire-red/10"
            data-testid="cancel-save-btn"
          >
            Abbrechen
          </Button>
          <Button 
            onClick={handleSave}
            disabled={!name.trim() || loading}
            className="bg-lunefire-red hover:bg-lunefire-red/90 text-white font-display uppercase tracking-wider"
            data-testid="confirm-save-btn"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Save className="w-4 h-4 mr-2" />
            )}
            Speichern
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveScenarioModal;
